// Copyright (C) 2023 TANNER AG

const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()\-_+={}[\]|/:;"'<>,.?\\€]).{8,}$/;
export const isValidPassword = (password: string, confirmPassword: string) =>
    password === confirmPassword && PASSWORD_REGEX.test(password);
